import { render, staticRenderFns } from "./PaymentItem.vue?vue&type=template&id=17b886f6&scoped=true&"
import script from "./PaymentItem.vue?vue&type=script&lang=js&"
export * from "./PaymentItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentItem.vue?vue&type=style&index=0&id=17b886f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b886f6",
  null
  
)

export default component.exports